import type { LinkingSuggestion } from "@/lib/api/types";
import { STATUS_LABEL, formatScore, shortUrl, splitSentence } from "@/lib/links";

export function SuggestionCard({
  item,
  busy,
  onDecide,
}: {
  item: LinkingSuggestion;
  busy: boolean;
  onDecide: (status: LinkingSuggestion["status"]) => void;
}) {
  const parts = item.sentence && item.anchor ? splitSentence(item.sentence, item.anchor) : null;
  return (
    <article aria-label={`Vorschlag ${shortUrl(item.source)} nach ${shortUrl(item.target)}`} className="flex flex-col gap-2.5 border-b border-neutral-bg px-5 py-4">
      <div className="flex flex-wrap items-center gap-2 text-[13px]">
        <span className="break-all font-mono text-[#3a424a]">{shortUrl(item.source)}</span>
        <span aria-label="verlinkt auf">→</span>
        <span className="break-all font-mono text-accent">{shortUrl(item.target)}</span>
        <span className="flex-1" />
        <span className="rounded bg-info-bg px-2 py-0.5 font-mono text-[13px] font-semibold text-info">Score {formatScore(item.score)}</span>
      </div>
      {item.target_title && <div className="text-xs text-muted">Ziel: {item.target_title}</div>}
      {parts ? (
        <p className="rounded-md bg-[#f7f8f7] px-3 py-2.5 text-sm leading-relaxed">
          {parts.pre}
          <mark className="rounded bg-[#dce7f5] px-0.5 font-medium text-[#123a6b]">{parts.anchor}</mark>
          {parts.post}
        </p>
      ) : (
        <p className="rounded-md bg-warning-bg px-3 py-2.5 text-sm text-warning">{item.note ?? "Kein Satz gefunden: Link im Text selbst ergänzen."}</p>
      )}
      <div className="flex flex-wrap items-center gap-1.5">
        {item.reasons.map((reason) => (
          <span key={reason} className="rounded bg-[#f0f2f1] px-2 py-0.5 text-xs text-[#3a424a]">
            {reason}
          </span>
        ))}
        <span className="flex-1" />
        {item.status === "offen" ? (
          <>
            <button
              type="button"
              disabled={busy}
              onClick={() => onDecide("uebernommen")}
              className="h-11 rounded-md bg-accent px-3.5 text-[13px] font-medium text-white disabled:opacity-60"
            >
              Übernehmen
            </button>
            <button
              type="button"
              disabled={busy}
              onClick={() => onDecide("verworfen")}
              className="h-11 rounded-md border border-field bg-white px-3.5 text-[13px] disabled:opacity-60"
            >
              Verwerfen
            </button>
          </>
        ) : (
          <>
            <span
              className={`rounded px-2.5 py-1 text-[13px] font-medium ${item.status === "uebernommen" ? "bg-success-bg text-success" : "bg-neutral-bg text-muted"}`}
            >
              {STATUS_LABEL[item.status]}
            </span>
            <button type="button" disabled={busy} onClick={() => onDecide("offen")} className="h-11 rounded-md px-3 text-[13px] text-accent underline disabled:opacity-60">
              Rückgängig
            </button>
          </>
        )}
      </div>
    </article>
  );
}
